import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Interfaces
import { ITimezone } from '@interfaces/timezones.interface';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  private httpClient = inject(HttpClient);

  public getTimezones(): Observable<{ timezones: ITimezone[] }> {
    return this.httpClient.get<{ timezones: ITimezone[] }>('/timezones');
  }
}
